window.o_order.basket.Add2Wishlist = function (basketItem) {
  if (basketItem) {
    this.add2WlButton = basketItem.querySelector('.or_js_add2WishlistButton');

    this.resetMessages(basketItem);

    basketItem.classList.add("or_add2Wishlist--visible");
    basketItem.setAttribute("data-initialized", "true");

    this.resetMessages(basketItem);
    this.add2WlButton.addEventListener('click', this.onSubmit.bind(this, basketItem));
  }
};

window.o_order.basket.Add2Wishlist.prototype.onSubmit = function onSubmit(basketItem) {
  const variationId = basketItem.dataset.variationId;
  const basketItemId = basketItem.dataset.basketItemId;
  const trackingBasketId = basketItem.dataset.trackingBasketId

  this.addToWishlist(variationId, basketItemId, trackingBasketId);
};

window.o_order.basket.Add2Wishlist.prototype.addToWishlist = function addToWishlist(variationId, basketItemId, trackingBasketId) {

  const payload = {
    variationId,
    addedFrom: "Basket",
    qualified: true
  }

  o_global.eventQBus.emit("ft1.wishlist.add", payload)

  window.o_order.basket.add2NewWishlist.success({
    basketItemId,
    variationId,
    trackingBasketId
  })
};

window.o_order.basket.Add2Wishlist.prototype.resetMessages = function resetMsg(basketItem) {
  const successMsgClass = "or_add2Wishlist__msg--success";
  const errorMsgClass = "or_add2Wishlist__msg--error";

  function removeElementFrom(selector, parent) {
    const el = parent.querySelector(selector);
    if (el) {
      el.parentNode.removeChild(el);
    }
  }

  removeElementFrom('.' + successMsgClass, basketItem);
  removeElementFrom('.' + errorMsgClass, basketItem);
};

/*🤫*/
window.o_order.basket.add2NewWishlist = window.o_order.basket.add2NewWishlist || (function () {

  function fadeOutAfter5Seconds(element) {
    if (element) {
      setTimeout(function () {
        o_util.animation.fadeOut(element, function () {
          element.style.display = "none";
        })
      }, 5000);
    }
  }

  function trackMoveEvent(wishlistData) {
    const id = 'order_variation_mv_to_wl';
    window.o_order.tracking.submitEventMerge({
      name: 'move',
      features: [
        {
          id,
          name: 'MovedToWishlist',
          status: 'moved',
          labels: {
            order_BasketId: wishlistData.trackingBasketId
          }
        },
        {
          id: `${id}_1`,
          variationId: wishlistData.variationId,
          name: 'Variation',
          parentId: id,
          status: 'moved',
          labels: {}
        }]
    });
  }

  function prependErrorMessage(item, messageText) {
    var msgContainer = document.createElement('div');
    msgContainer.classList.add("or_basketItem__add2Wishlist__msg--error");
    msgContainer.innerHTML = '<div class="p_message p_message--error">' +
      '<button type="button" class="p_message__button" onclick="this.parentNode.parentNode.style.display=\'none\'">x</button>' +
      messageText +
      '</div>';

    var inserted = item.parentNode.insertBefore(msgContainer, item);

    fadeOutAfter5Seconds(inserted);
  }

  function addToWishlistSuccess(wishlistData) {
    var thisItem = document.getElementById("basketItem" + wishlistData.basketItemId)

    function deleteFromBasketSuccess(data, redirectUrl) {
      if (redirectUrl) {
        trackMoveEvent(wishlistData);
        window.o_order.basket.view.redirectTo(redirectUrl)
      } else {
        window.o_order.basket.view.updateBasket(data);
        trackMoveEvent(wishlistData);
      }
    }

    function deleteFromBasketError() {
      prependErrorMessage(
        thisItem,
        'Der Artikel wurde auf dem Merkzettel gespeichert. Das Entfernen aus dem Warenkorb war nicht möglich. Bitte lösche den Artikel.',
      );
    }

    window.o_order.basket.service.deleteItem(wishlistData.basketItemId, deleteFromBasketSuccess, deleteFromBasketError);
  }

  function update() {
    var allAdd2WishlistContainers = document.querySelectorAll('.or_js_add2Wishlist');
    [].forEach.call(allAdd2WishlistContainers, function (item) {
      if (item.dataset.initialized !== "true") {
        new window.o_order.basket.Add2Wishlist(item);
      }
    });
  }

  function triggerAdd2WishlistUpdateOnBasketUpdate() {
    window.o_order.common.basketChange.onBasketChange(function () {
      if (window.o_order.basket.add2NewWishlist && typeof window.o_order.basket.add2NewWishlist.update === 'function') {
        window.o_order.basket.add2NewWishlist.update();
      }
    });
  }

  return {
    success: addToWishlistSuccess,
    update: update,
    triggerAdd2WishlistUpdateOnBasketUpdate: triggerAdd2WishlistUpdateOnBasketUpdate
  }
}());

window.o_global.eventQBus.onModuleLoaded('ft1.order-core.basket', ['ft1.order-core.common-public']).then(() => {
  window.o_order.basket.add2NewWishlist.update();

  if (!window.o_order.basket.add2NewWishlist.initialized) {
    window.o_order.basket.add2NewWishlist.triggerAdd2WishlistUpdateOnBasketUpdate();
    window.o_order.basket.add2NewWishlist.initialized = true
  }
});
